import {
  DEFAULT_PROJECT,
  PROJECT_COLORS,
  normalizePanelThickness,
  makeId,
} from "../fixtures/defaults";
import { clone } from "./clone";
import { normalizeRestStock } from "./restStock";
import { normalizeExportAnnotations, normalizeWerkplan } from "../export/werkplanDefaults";

export function normalizeProject(raw) {
  if (!raw) return clone(DEFAULT_PROJECT);
  const sourcePanel = {
    ...clone(DEFAULT_PROJECT.sourcePanel),
    ...(raw.sourcePanel || {}),
    defaultThickness:
      raw.sourcePanel?.defaultThickness ??
      DEFAULT_PROJECT.sourcePanel.defaultThickness,
  };

  const projects = Array.isArray(raw.projects) ? raw.projects : [];
  return {
    ...clone(DEFAULT_PROJECT),
    ...raw,
    sourcePanel,
    restStock: normalizeRestStock(raw.restStock, sourcePanel.defaultThickness),
    werkplan: normalizeWerkplan(raw.werkplan),
    exportAnnotations: normalizeExportAnnotations(raw.exportAnnotations),
    projects: projects.map((project, projectIndex) => ({
      ...project,
      id: project.id || makeId(),
      color: project.color || PROJECT_COLORS[projectIndex % PROJECT_COLORS.length],
      panels: (project.panels || []).map((panel) => ({
        ...panel,
        id: panel.id || makeId(),
        thickness: normalizePanelThickness(
          panel.thickness ?? sourcePanel.defaultThickness,
          sourcePanel.defaultThickness,
        ),
        quantity: panel.quantity ?? 1,
        hidden: Boolean(panel.hidden),
        edges: panel.edges || {},
      })),
    })),
  };
}
